import * as React from 'react';
import { Overlay } from '@fluentui/react/lib/Overlay';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';

export interface ICrLoadingOverlayWelcomeCatProps {
    isLoading: boolean;
}

export class CrLoadingOverlayWelcomeCat extends React.Component<ICrLoadingOverlayWelcomeCatProps, {}> {
    public render(): JSX.Element {
        return (
            <div>
                {this.props.isLoading &&
                    <Overlay style={{ background: 'white', zIndex: 1, paddingTop: '50px', marginTop: '80px' }}>
                        <Spinner size={SpinnerSize.large} label="Loading..." />
                    </Overlay>
                }
            </div>
        );
    }
}